<template>
  <div class="time-selector">
    <button
      class="btn justify-space-between w-150px"
      @click="isModalOpen = !isModalOpen"
    >
      <span v-if="time === ''">{{ buttonPlaceholder }}</span>
      <span v-else class="ink-01-emphasis--text">{{ time }}</span>
      <v-icon>arrow_drop_down</v-icon>
    </button>
    <div
      class="time-selector__dialog block-3 d-flex h-360px"
      v-if="isModalOpen"
    >
      <div class="time-selector__options">
        <div
          class="time-selector__option"
          v-for="val1 in options.firstValue"
          :key="`firstValue-${val1}`"
          @click="setFirstValue(val1)"
        >
          {{ val1 }}
        </div>
      </div>
      <div class="time-selector__options">
        <div
          class="time-selector__option"
          v-for="val2 in options.secondValue"
          :key="`secondValue-${val2}`"
          @click="setSecondValue(val2)"
        >
          {{ val2 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstValue: {
      type: String,
      default: '',
    },
    secondValue: {
      type: String,
      default: '',
    },
    buttonPlaceholder: {
      type: String,
      default: '請選擇',
    },
  },
  data() {
    return {
      isModalOpen: false,
      options: {
        firstValue: [...Array(100).keys()].map((i) => `${i + 2020}`),
        secondValue: [...Array(12).keys()].map((i) =>
          `${i + 1}`.padStart(2, '0'),
        ),
      },
    };
  },
  computed: {
    time() {
      const vm = this;
      if (vm.firstValue === '' && vm.secondValue === '') {
        return '';
      }
      if (vm.firstValue === '' && vm.secondValue !== '') {
        const thisYear = new Date().getFullYear();
        this.setFirstValue(`${thisYear}`);
      }
      if (vm.firstValue !== '' && vm.secondValue === '') {
        this.setSecondValue('01');
      }
      return `${vm.firstValue}.${vm.secondValue}`;
    },
  },
  methods: {
    setFirstValue(value) {
      this.$emit('update:firstValue', value);
    },
    setSecondValue(value) {
      this.$emit('update:secondValue', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.time-selector {
  position: relative;

  &__dialog {
    position: absolute;
    width: 100%;
    margin-top: 4px;
    background-color: #fff;
    z-index: 1;
  }

  &__options {
    width: 50%;
    overflow: auto;
  }
  &__option {
    padding-top: 10px;
    padding-bottom: 14px;
    padding-left: 10px;
    &:hover {
      background-color: $brand-100;
      cursor: pointer;
    }
  }
}
</style>
